import {gql} from 'apollo-boost'

export const GET_INGREDIENT_CATEGORIES = gql`
    query {
        ingredientCategories {
            id
            name
            ingredient { id name }
        }
    }
`

export const ADD_INGREDIENT_CATEGORY = gql`
    mutation($name: String!) {
        createIngredientCategory(name: $name) {
            id
            name
        }
    }
`

export const UPDATE_INGREDIENT_CATEGORY = gql`
    mutation($id: ID! $name: String!) {
        updateIngredientCategory(id: $id name: $name) {
            id
            name
        }
    }
`

export const DELETE_INGREDIENT_CATEGORY = gql`
    mutation($id: ID!) {
        deleteIngredientCategory(id: $id) {
            name
        }
    }
`